import Suspense from "components/shared/Suspense";
import LikeButton from "components/likes/LikeButton";
import TextLink from "hardcover-ui/components/TextLink";
import { lazy } from "react";
import PrivacyIcon from "components/shared/PrivacyIcon";
import { ClientDateTime } from "components/shared/ClientDatetime";
import ReadingJournalEntryEvent from "../ReadingJournalEntry/ReadingJournalEntryEvent/ReadingJournalEntryEvent";
import ReadingJournalPosition from "../ReadingJournalPosition/ReadingJournalPosition";
import JournalTags from "./JournalTags";
import { ReadingJournalSerializersJournal, PageSerializersBooksLayout, UserSerializersUserByline } from "types/serializers";

const ReadingJournalControls = lazy(
  () =>
    import(
      "../ReadingJournalEntry/ReadingJournalControls/ReadingJournalControls"
    )
);

export default function ReadingJournalCard({
  book,
  className = "",
  isOwner,
  journal,
  user,
}: {
  book: PageSerializersBooksLayout;
  className?: string;
  isOwner: boolean;
  journal: ReadingJournalSerializersJournal;
  user: UserSerializersUserByline;
}) {
  return (
    <div className={className}>
      <ReadingJournalEntryEvent journal={journal} book={book} user={user} />

      <div className="mt-4 space-y-2">
        <JournalTags tags={journal.tags} />
        <div className="flex flex-row justify-between items-baseline">
          <div className="flex flex-row items-center space-x-2">
            <LikeButton likeable={journal} showLikes={false} />

            <PrivacyIcon privacySettingId={journal.privacySettingId} />

            <ReadingJournalPosition
              position={journal.metadata?.position || null}
            />

            {isOwner ? (
              <Suspense>
                <ReadingJournalControls journal={journal} book={book} />
              </Suspense>
            ) : (
              false
            )}
          </div>
          <TextLink
            href={`/books/${book.slug}/journals/@${user.username}#entry-${journal.id}`}
            variant="secondary"
            size="sm"
          >
            <ClientDateTime date={journal.actionAt} />
          </TextLink>
        </div>
      </div>
    </div>
  );
}
